// A real editable element is required to summon iOS/Android keyboards. Keep one
// sentinel before the caret so Backspace also fires when no new text is pending.
const SENTINEL = '\u200b';

export function bindBoardKeyboard(input, { insert, erase, keydown, blur }) {
    let composing = false;
    const reset = () => {
        input.value = SENTINEL;
        input.setSelectionRange(1, 1);
    };
    const commit = () => {
        const text = input.value.startsWith(SENTINEL) ? input.value.slice(1) : input.value;
        if (text) insert(text);
        reset();
    };
    input.onkeydown = event => {
        if (!composing) keydown(event);
    };
    input.onbeforeinput = event => {
        if (composing || event.isComposing || !event.cancelable) return;
        if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') {
            event.preventDefault();
            erase(event.inputType === 'deleteContentBackward');
            reset();
        }
    };
    input.oninput = event => {
        if (composing || event.isComposing) return;
        // Some mobile keyboards provide only a non-cancelable input event.
        if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') {
            erase(event.inputType === 'deleteContentBackward');
            reset();
        } else commit();
    };
    input.oncompositionstart = () => { composing = true; };
    input.oncompositionend = () => { composing = false; commit(); };
    input.onpaste = event => {
        event.preventDefault();
        insert(event.clipboardData.getData('text/plain'), true);
        reset();
    };
    input.onblur = () => { composing = false; reset(); blur(); };
    reset();
}
